import {writable} from 'svelte/store';

let content = [];
const layers = writable(content);

layers.layer = (index, uri, commit) => {
	content[index] = uri;
	if (commit) layers.commit();
};

layers.commit = () => {
	layers.set(content);
}

export default layers;